import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { Mail } from 'lucide-react';

const ContactTeaser = () => {
  const { t } = useLanguage();
  const { settings } = useSiteSettings();
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-16 md:py-24 lg:py-32 px-6 bg-secondary/30" aria-label={t.contactTeaserTitle}>
      <div ref={ref} className="max-w-2xl mx-auto text-center">
        <div className={`reveal-on-scroll ${isVisible ? 'revealed' : ''}`}>
          <div className="w-12 h-px bg-gold mx-auto mb-8" aria-hidden="true" />
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-foreground mb-4">
            {t.contactTeaserTitle}
          </h2>
          <p className="text-muted-foreground leading-relaxed mb-8 max-w-lg mx-auto">
            {t.contactTeaserText}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-block px-10 py-4 bg-foreground text-background text-xs tracking-[0.2em] uppercase hover:bg-foreground/90 transition-colors rounded-full"
            >
              {t.contactTeaserCta}
            </Link>

            {settings.contact_email && settings.show_contact_details && (
              <a
                href={`mailto:${settings.contact_email}`}
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                <Mail className="w-4 h-4" />
                {settings.contact_email}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactTeaser;
